import GuidedTour from "../GuidedTour";
import { StepType } from "@reactour/tour";

export const FilterSteps: StepType[] = [
  {
    selector: ".Filter .form-add-industry",
    position: "right",
    content: (
      <GuidedTour
        title="Customize Your Search"
        content="HEPPAI categorizes extracted keywords, enabling customization to refine your search, saving time, and helping you find ideal candidates."
      />
    ),
  },
  {
    selector: ".Filter .btn-continue",
    position: "right",
    content: (
      <GuidedTour
        title="Continue"
        content="Click continue to come Filter step."
      />
    ),
  },
];
